<div class="container-fluid">
  <app-header titleText="IMPORT CUSTOMER" i18n-titleText></app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/customer_circle.png" alt="Customer Icon" class="card-icon" />
      <h5 i18n>Customer Import</h5>

      <div class="row">
        <div class="col-sm-3">
          <a href="assets/xlsx/CustomerImport.xlsx" class="btn btn-bidit-navigate" i18n>Download Sample File</a>
        </div>
        <div *ngIf="!isRequesting && summary && summary.customerCount == 0" class="col-sm-9 right-align">
          <button type="submit" class="btn btn-bidit-action" (click)="importFile()" i18n>Import File</button>
        </div>
        <div *ngIf="!isRequesting && summary && summary.customerCount > 0" class="col-sm-9 right-align">
          <button type="submit" class="btn btn-bidit-action" (click)="cancelImport()" i18n>Cancel Import</button>
          <button type="button" class="btn btn-bidit-action ml-1" (click)="applyImport()" i18n>Apply Import</button>
        </div>
        <div *ngIf="isRequesting" class="col-sm-9 right-align">
          <app-spinner [isRunning]="isRequesting"></app-spinner>
        </div>
      </div>

      <h5 *ngIf="summary?.customerCount == 0" class="mt-5" i18n>Click "Import File" to import customer data</h5>
      <div [hidden]="!summary || summary.customerCount == 0">
        <h5 class="mt-5" i18n>Review the imported data below.  If everything looks correct click 'Apply Import'</h5>
        <mat-table class="table table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                   matSort matSortActive="customerName" matSortDirection="asc">
          <ng-container matColumnDef="customerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer Name</mat-header-cell>
            <mat-cell *matCellDef="let customer">
              {{customer.customer_BusinessName}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="address">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Address</mat-header-cell>
            <mat-cell *matCellDef="let customer">
                <div fxLayout="column">
                    <div>
                        {{customer.customer_Address1}}
                    </div>
                    <div *ngIf>
                        {{customer.customer_Address2}}
                    </div>
                    <div>
                        {{customer.customer_City}} {{customer.customer_State}}, {{customer.customer_Postal}}
                    </div>
                    <div *ngIf="!customer.customer_Address1" class="bidit-alert">
                        <span i18n>No customer address 1 provided</span>
                    </div>
                    <div *ngIf="!customer.customer_City" class="bidit-alert">
                        <span i18n>No customer city provided</span>
                    </div>
                    <div *ngIf="!customer.customer_State" class="bidit-alert">
                        <span i18n>No customer state provided</span>
                    </div>
                    <div *ngIf="!customer.customer_Postal" class="bidit-alert">
                        <span i18n>No customer zip code provided</span>
                    </div>
                </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="contact">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Contact</mat-header-cell>
            <mat-cell *matCellDef="let customer">
                <div fxLayout="column">
                    <div>
                        {{customer.contact_FirstName}} {{customer.contact_LastName}}
                    </div>
                    <div>
                        <span i18n>Email:</span> {{customer.contact_Email}}
                    </div>
                    <div>
                        <span i18n>Phone:</span> {{customer.contact_Phone}}
                    </div>
                    <div *ngIf="!customer.contact_FirstName" class="bidit-alert">
                        <span i18n>No contact first name provided</span>
                    </div>
                    <div *ngIf="!customer.contact_LastName" class="bidit-alert">
                        <span i18n>No contact last name provided</span>
                    </div>
                    <div *ngIf="!customer.contact_Email && !customer.contact_Phone && !customer.contact_Mobile" class="bidit-alert">
                        <span i18n>No contact email or phone provided</span>
                    </div>
                </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="summary">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Summary</mat-header-cell>
            <mat-cell *matCellDef="let customer">
              <div fxLayout="column">
                <div *ngIf="customer.office">
                  <span i18n>Office:</span> {{customer.office.office_Name}}
                </div>
                <div *ngIf="!customer.office" class="bidit-alert">
                  <span i18n>Could not find office:</span> {{customer.office_Name}}
                </div>
                <div *ngIf="customer.customerType">
                  <span i18n>Customer Type:</span> {{customer.customerType.customerType_Desc}}
                </div>
                <div *ngIf="!customer.customerType" class="bidit-alert">
                  <span i18n>Could not find customer type:</span> {{customer.customerType_Name}}
                </div>
                <div *ngIf="customer.paymentTerm">
                  <span i18n>Payment Term:</span> {{customer.paymentTerm.paymentTerm_Desc}}
                </div>
                <div *ngIf="!customer.paymentTerm" class="bidit-alert">
                  <span i18n>Could not find payment term:</span> {{customer.paymentTerm_Name}}
                </div>
                <div *ngIf="customer.paymentType">
                  <span i18n>Payment Type:</span> {{customer.paymentType.paymentType_Desc}}
                </div>
                <div *ngIf="!customer.paymentType" class="bidit-alert">
                  <span i18n>Could not find payment type:</span> {{customer.paymentType_Name}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="salesperson">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
            <mat-cell *matCellDef="let customer">
              <div fxLayout="column">
                <div *ngIf="customer.assignedTo">
                  {{customer.assignedTo.firstName}} {{customer.assignedTo.lastName}}
                </div>
                <div *ngIf="!customer.assignedTo" class="bidit-alert">
                  <span i18n>Could not find salesperson:</span> {{customer.assignedTo_FirstName}} {{customer.assignedTo_LastName}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header"></mat-header-cell>
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let customer">
              <button type="button" class="btn btn-bidit-warn mr-1" (click)="deleteCustomerImport(customer)" i18n>Delete</button>
              <button type="button" class="btn btn-bidit-navigate" (click)="editCustomerImport(customer)" i18n>Edit</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns">
          </mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" [class.alert-danger]="invalidImport(row)"></mat-row>
        </mat-table>

        <mat-paginator [length]="summary?.customerCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
      </div>
      
    </div>
  </div>
</div>
